import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { PLUGIN_TYPE } from '@/typings/enums/PLUGIN_TYPE';

type Props = SetupProps<typeof UnlockModuleAsideSetupService.props>

export default class UnlockModuleAsideSetupService extends BaseSetupService<Props> {
	static readonly props = {
		showSelectOnly: Boolean,
		type: {
			type: Number,
			default: undefined,
		},
	};

	private readonly state = reactive({ showSelect: true });

	get showSelect () { return this.state.showSelect; }
	set showSelect (val) { this.state.showSelect = val; }

	get unlockModuleTitle () { return `Demandez le déblocage du module de ${this.moduleTypeLabel}`;}

	get moduleTypeLabel () {
		switch (this.props.type) {
		case (PLUGIN_TYPE.Order):
			return 'Commandes';
		// Ajouter les autres modules
		default:
			return 'inconnue';
		}
	}

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		if (this.props.showSelectOnly) {
			this.state.showSelect = true;
		}
	}
}
